import { Edit, useForm } from '@refinedev/antd';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { MonoCode } from '@lebinatikra/rtl-utils';
import type { Locale } from '@lebinatikra/shared-types';

interface UserForm {
  id: string;
  default_locale: Locale;
}

const LOCALES: Locale[] = ['he', 'en', 'yi', 'fr', 'ru'];

export function UserEdit() {
  const { t } = useTranslation();
  const { formProps, saveButtonProps, query } = useForm<UserForm>();
  const id = query?.data?.data?.id;

  return (
    <Edit saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        {id ? (
          <Form.Item label={t('common.id')}>
            {/* rtl-utils:bidi-wrapped */}
            <MonoCode>{id}</MonoCode>
          </Form.Item>
        ) : null}
        <Form.Item
          name="default_locale"
          label={t('fields.default_locale')}
          rules={[{ required: true }]}
        >
          <Select options={LOCALES.map((l) => ({ value: l, label: l }))} />
        </Form.Item>
      </Form>
    </Edit>
  );
}
